<template>
      <button class="menu-button" @click="goToMenu">
        <span>Esplora il menu</span>
        <i class="fas fa-utensils"></i> <!-- Icona di coltello e forchetta -->
      </button>
  </template>
  
  <script>
  import { gsap } from "gsap";
  
  export default {
    mounted() {
      this.animateButton();
    },
    methods: {
      animateButton() {
        gsap.from(".menu-button", {
          opacity: 0,
          y: 50,
          duration: 1,
          delay: 0.5, // Ritardo per far partire l'animazione dopo 2 secondi dal caricamento della pagina
          ease: "power2.out"
        });
        gsap.to(".menu-button", {
          scale: 1.2, // Ingrandimento del pulsante
          yoyo: true, // Ripete l'animazione andando avanti e indietro
          repeat: -1, // Ripetizione infinita
          duration: 0.5, // Durata di ogni singola animazione
          delay: 1// Ritardo per far partire l'animazione dopo 3 secondi dal caricamento della pagina
        });
      },
      goToMenu() {
        this.$router.push('/menu');
      }
    }
  };
  </script>
  
  <style scoped>

  .menu-button {
    background-color: var(--accent-color);/* #FFA500 */
    color: white;
    border: none;
    border-radius: 20px;
    padding: 10px 20px;
    font-size: 18px;
    cursor: pointer;
    box-shadow: 2px 4px 14px rgba(0, 0, 0, 0.5); 
    display: block;
    margin: auto;
  }
  
  .menu-button:hover {
    background-color: var(--accent-color-clicked);
  }
  .menu-button span {
    margin-right: 10px;
  }
  </style>
  